import script from "./farmaciAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./farmaciAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"

import "./farmaciAggiuntiveEdit.vue?vue&type=style&index=0&id=3324d728&lang=css"

const __exports__ = script;

export default __exports__